import {getFormattedName} from './FormatterUtil';

import type {InternalTimeSearchResult} from '../types/SearchResult';
import {FormattedSearchItem} from '../types/FormattedSearchResult';
import {SearchResultVariant} from '../types/SearchResultVariant';

const getFormattedInternalTimeHighlight = () => {
	// Default to company_project_id_fallback if highlight is undefined
	const highlightField = 'Internal Time';
	const highlightValue = '';

	return {
		highlightField,
		highlightValue,
	};
};

export interface FormattedInternalTime extends FormattedSearchItem {
	variant: SearchResultVariant.InternalTime;
}

type InternalTimeFormatterInput = {
	searchResult: InternalTimeSearchResult;
	trackAndHideSearch: (searchResult, openedInNewTab: boolean) => void;
};
export const internalTimeFormatter = ({
	searchResult,
	trackAndHideSearch,
}: InternalTimeFormatterInput): FormattedInternalTime => {
	const onSelect = (rank, openedInNewTab) => {
		trackAndHideSearch({id: searchResult.id, variant: searchResult.variant, rank: rank, searchResult}, !openedInNewTab);
	};

	const formattedName = getFormattedName(searchResult.name, searchResult.highlight);
	const formattedHighlight = getFormattedInternalTimeHighlight();

	return {
		title: searchResult.name,
		name: formattedName,
		highlight: formattedHighlight,
		variant: searchResult.variant,
		ariaLabel: `Search result. Type: Internal time. Title: ${searchResult.name}.`,
		onSelect,
	};
};
